import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import Select from "react-select";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import ProductDetailList from "./ProductDetailList";
import ProductDetailForm from "./ProductDetailForm";
import ManageUnits from "./ManageUnits/Index";
import { ADD_NEW } from "constants/commonConstants";

import {
  getProductCategoryListRequest,
  setProductCategoryId,
} from "store/actions";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import productCategoryReducer from "store/Masters/ProductCategory/reducer";
import productCategorySaga from "store/Masters/ProductCategory/saga";
import productDetailReducer from "store/ProductDetail/reducer";
import productDetailSaga from "store/ProductDetail/saga";
import { selectSortedProductCategories } from "store/Masters/ProductCategory/selector";
import { makeProductDetailSelectField } from "store/ProductDetail/selector";

const productCategoryKey = "ProductCategoryMaster";

const withProductCategoryReducer = injectReducer({
  key: productCategoryKey,
  reducer: productCategoryReducer,
});
const withProductCategorySaga = injectSaga({
  key: productCategoryKey,
  saga: productCategorySaga,
});

const productDetailKey = "ProductDetail";

const withProductDetailReducer = injectReducer({
  key: productDetailKey,
  reducer: productDetailReducer,
});
const withProductDetailSaga = injectSaga({
  key: productDetailKey,
  saga: productDetailSaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      unitDialog: false,
      productDetailData: null,
      productCategoryId: null,
    };

    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.props.getProductCategoryListRequest();
  }

  componentDidUpdate() {
    if (this.props.productCategoryId !== this.state.productCategoryId) {
      this.setState({
        productCategoryId: this.props.productCategoryId,
      });
    }
  }

  onProductDetailInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
      unitDialog: false,
      productDetailData: null,
    });
  };

  viewProductDetail = (productDetail) => {
    this.setState({
      formDialog: true,
      productDetailData: productDetail,
    });
  };

  viewManageUnit = (productDetail) => {
    this.setState({
      unitDialog: true,
      productDetailData: productDetail,
    });
  };

  handleChangeProductCategory = (opt, e) => {
    this.props.setProductCategoryId(opt ? opt.value : null);
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <ProductDetailForm
            formDialog={this.state.formDialog}
            productDetailRecord={this.state.productDetailData}
            closeModal={() => this.onProductDetailInsertUpdateSuccess()}
            productCategoryId={this.state.productCategoryId}
          ></ProductDetailForm>

          {this.state.unitDialog && (
            <ManageUnits
              formDialog={this.state.unitDialog}
              productDetailId={this.state.productDetailData.productDetailId}
              closeModal={() => this.onProductDetailInsertUpdateSuccess()}
            />
          )}

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between flex-column flex-sm-row">
                    <h4 className="mt-0 page-title">Product Detail</h4>
                    <button
                      className="my-2 btn btn-primary waves-effect waves-light"
                      onClick={() => this.viewProductDetail(null)}
                    >
                      {ADD_NEW}
                    </button>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Select
                      className="my-2 p-0 col-12 col-md-6 col-lg-3"
                      classNamePrefix="select"
                      name="productCategoryId"
                      placeholder="Select Product Category"
                      isSearchable={true}
                      options={this.props.sortedProductCategoryList}
                      onChange={this.handleChangeProductCategory}
                      value={this.props.sortedProductCategoryList.filter(
                        (option) =>
                          option.value === this.state.productCategoryId
                      )}
                    />
                  </div>

                  <ProductDetailList
                    onViewProductDetail={(values) =>
                      this.viewProductDetail(values)
                    }
                    onViewManageUnit={(values) => this.viewManageUnit(values)}
                    productCategoryId={this.state.productCategoryId}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = createStructuredSelector({
  sortedProductCategoryList: selectSortedProductCategories(),
  productCategoryId: makeProductDetailSelectField("productCategoryId"),
});

const withConnect = connect(mapStatetoProps, {
  getProductCategoryListRequest,
  setProductCategoryId,
});

export default compose(
  withConnect,
  withProductCategoryReducer,
  withProductCategorySaga,
  withProductDetailReducer,
  withProductDetailSaga,
  withRouter
)(Index);
